import * as React from 'react';
import { inject } from 'mobx-react';

import { PureComponentWithInjectedProps } from 'utils/injectedProps';
import Loading from 'components/Loading/Loading';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

type Props = {
  costCenter: Object,
};

type InjectedProps = {
  actionDrawerStore: TypeActionDrawerStore,
};

@inject('actionDrawerStore')
export default class ToggleCostCenterStatus extends PureComponentWithInjectedProps<
  Props,
  InjectedProps
> {
  async componentDidMount() {
    const { actionDrawerStore, costCenter } = this.props;

    actionDrawerStore.actionDrawerOpen = false;

    await actionDrawerStore.toggleCostCenterStatus(costCenter);

    actionDrawerStore.closeActionDrawer();
  }

  render() {
    return (
      <React.Fragment>
        <Loading />
      </React.Fragment>
    );
  }
}
